import apiEndpoints from '../../../apiEndpoints';
import { fetcher } from '../../utils/fetchers/fetcher';
import { LayoutDefinition } from '../../../types/types';

// GET appdefinitions/2.0/layouts/{id} — layout editor definition (apiMethods + objectForm + optional canvasForm).
export const requestLayoutDefinition = (
  layoutId: string,
  token: string | null,
  forceHeader?: string
): Promise<LayoutDefinition> =>
  fetcher<LayoutDefinition>(
    `${apiEndpoints.routes.layoutDefinitions}/${layoutId}`,
    'GET',
    token,
    forceHeader
  );
